import { render, staticRenderFns } from "./UserImportAssignments.vue?vue&type=template&id=ec21a9c6&"
import script from "./UserImportAssignments.vue?vue&type=script&lang=js&"
export * from "./UserImportAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports